export default __webpack_public_path__ + "f53b2e0192b1ab7c3de828bf53c6948c.png";